import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  currentFees: 'المستحق الآن',
  connectCost: 'تكلفة طلب التواصل: <tag> {{value}} ج.م </tag>',
  totalCost: 'التكلفة الاجمالية: <tag> {{value}} EGP </tag>',
  remainingCostNote:
    'سيتم خصم باقى التكلفة الاجمالية <tag>({{value}}ج.م)</tag> تلقائياً فى حالة قبول العميل طلب الاتصال',
  already_sent_to_user: 'الطلب تم ارساله بالفعل ',
  readyBrokerTitle: 'وسيط عقارى موثٌق جاهز لمساعدتك',
  helloUser: 'اهلاً {{user}}!',
  readyBrokerMessage:
    'يوجد وسيط عقاري موثّق على عقارماب يرغب في مساعدتك في بحثك عن عقار فى ({{location}}).',
  listingsCount: '{{count}} إعلانات على عقارماب',
  confirmNote:
    'بالضغط على زر الموافقة أدناه، سيتم قبول الطلب وستُشارك معلوماتك مع هذا الوسيط فقط حتى يتمكن من التواصل معك.',
  acceptText: 'قبول الطلب ومشاركة معلوماتك',
  cancelText: 'لا, شكراً',
  proposalAccepted: 'تم قبول الطلب بنجاح, وستشارك معلوماتك مع الوسيط',
  lead_request_already_sent: 'تم إرسال طلب الاتصال من قبل ',
  acceptRequest: 'قبول الطلب',
});
